import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateInputFillMode, DateInputRounded, DateInputSize } from '@progress/kendo-angular-dateinputs';
import { forkJoin } from 'rxjs';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { isEqual } from 'lodash';
import { RequestAPIService } from 'src/app/extensions/services/api/request-api.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'request-list-filter',
  templateUrl: './request-list-filter.component.html',
  styleUrls: ['./request-list-filter.component.scss'],
  standalone: false,
})
export class RequestListFilterComponent implements OnInit {
  public constructor(
    private _activeModal: NgbActiveModal,
    private _dictionaryAPIService: DictionaryAPIService,
    private _requestAPIService: RequestAPIService,
    private _translateService: TranslateService
  ) {}

  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: DateInputRounded = 'large';
  public sizeLarge: DateInputSize = 'large';
  public dictionaryAssetDocumentRequestTypeDataSource: app.models.DictionaryDataModel[];
  public dictionaryContractModificationRequestTypeDataSource: app.models.DictionaryDataModel[];
  public dictionaryClientDataRequestTypeDataSource: app.models.DictionaryDataModel[];
  private requestModalFilters: app.models.GetRequestsForAdministrationModelPageFilter;
  private initialFilterState: app.models.GetRequestsForAdministrationModelPageFilter;
  public adminUsersDataSource: app.models.DictionaryDataModel[];

  public startDate: Date;
  public endDate: Date;
  public selectedRequestTypeId: string = '';
  public selectedAdminUser: app.models.DictionaryDataModel = {
    id: null,
    code: '',
    value: '',
  } as app.models.DictionaryDataModel;

  public ngOnInit(): void {
    this.loadRequestDictionaries();
    if (this.requestModalFilters.startDate) {
      this.startDate = new Date(this.requestModalFilters.startDate);
    }
    if (this.requestModalFilters.endDate) {
      this.endDate = new Date(this.requestModalFilters.endDate);
    }
    if (this.requestModalFilters.requestTypeId) {
      this.selectedRequestTypeId = this.requestModalFilters.requestTypeId;
    }
    if (this.requestModalFilters.adminUser) {
      this.selectedAdminUser = this.requestModalFilters.adminUser;
    }
  }

  loadRequestDictionaries() {
    const source = forkJoin([
      this._dictionaryAPIService.getDictionaryAssetDocumentRequestTypes(),
      this._dictionaryAPIService.getDictionaryContractModificationRequestType(),
      this._dictionaryAPIService.getDictionaryClientDataRequestTypes(),
      this._requestAPIService.getAdminUsersByModifiedRequestStatus(),
    ]);

    source.subscribe(
      ([
        dictionaryAssetDocumentRequestTypes,
        dictionaryContractModificationRequestTypes,
        getDictionaryClientDataRequestTypes,
        adminUsersDataSource,
      ]) => {
        this.dictionaryAssetDocumentRequestTypeDataSource = dictionaryAssetDocumentRequestTypes;
        this.dictionaryContractModificationRequestTypeDataSource = dictionaryContractModificationRequestTypes;
        this.dictionaryClientDataRequestTypeDataSource = getDictionaryClientDataRequestTypes;
        this.adminUsersDataSource = adminUsersDataSource;
        this.adminUsersDataSource.unshift({
          id: null,
          code: 'Unprocessed',
          value: this._translateService.instant('request.filterPopup.unprocessedRequests'),
        });
      }
    );
  }

  public closeHandler() {
    this._activeModal.close(false);
  }

  public resetHandler() {
    this.requestModalFilters.startDate = null;
    this.requestModalFilters.endDate = null;
    this.requestModalFilters.requestTypeId = '';
    this.requestModalFilters.adminUser = null;
    this._activeModal.close(isEqual(this.requestModalFilters, this.initialFilterState) ? false : 0);
  }

  public applyFilterHandler() {
    this.requestModalFilters.requestTypeId = this.selectedRequestTypeId;
    if (this.startDate) {
      this.requestModalFilters.startDate = this.startDate;
    }
    if (this.endDate) {
      this.requestModalFilters.endDate = this.endDate;
    }
    if (this.selectedAdminUser) {
      this.requestModalFilters.adminUser = this.selectedAdminUser;
    }

    let filterCount = 0;
    if (this.requestModalFilters.requestTypeId) filterCount++;
    if (this.requestModalFilters.startDate != null) filterCount++;
    if (this.requestModalFilters.endDate != null) filterCount++;
    if (this.requestModalFilters.adminUser) filterCount++;

    this._activeModal.close(isEqual(this.requestModalFilters, this.initialFilterState) ? false : filterCount);
  }

  disabledPastDates = (date: Date) => {
    return date < this.requestModalFilters.startDate;
  };

  startDateChangeHandler() {
    if (this.requestModalFilters.endDate < this.requestModalFilters.startDate) {
      this.requestModalFilters.endDate = undefined;
    }
  }
}
